(ns frontend.view.settings2.web-form.events
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.entity :as entity-actions]
   [frontend.conn :as conn]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.curtains.settings-curtain.view :as settings-curtain]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.notification.view :as notification-modal]
   [frontend.view.settings2.web-form.db :as db]
   [frontend.view.settings2.web-form.event :as event]
   [potpuri.core :refer [fn-> fn->>]]
   [promesa.core :as p]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.dom-globals :as dg]))

(defn create-webentry
  [feature-on?]
  (if-not feature-on?
    (modals/open-modal!
     notification-modal/modal-key
     {:ok-button-text (loc/tr :close)
      :title          (loc/tr :multiple-web-forms)
      :body-text      [:span
                       (loc/tr :multiple-web-forms-feature-info)
                       [:a {:href (str "mailto:" (loc/tr :mail-address-sales))}
                        (loc/tr :mail-address-sales)]
                       (loc/tr :multiple-web-forms-feature-info-2)]})
    (f-entity/open-creator! :entity.type/webentry
                            {:on-ok!           (fn [{:keys [new-entity-id close-cb!]}]
                                                 (swap! db/webentry-state assoc :selected-webentry new-entity-id)
                                                 (close-cb!))
                             :show-error-view? true})))

(defn save-webform!
  [webentry attribute new-value on-success! on-error!]
  (let [webentry-id (:db/id webentry)]
    (entity-actions/*->field-update! webentry-id
                                     attribute
                                     new-value
                                     on-success!
                                     on-error!)))

(defn save-color!
  [webentry attribute new-value on-success! on-error!]
  (let [webentry-id (:db/id webentry)
        msg {:db/id     webentry-id
             :attribute attribute
             :value     new-value}]
    (-> (conn/sendp! :webentry/update-color msg)
        (p/then on-success!)
        (p/catch on-error!))))

(defn file-logo-chosen
  [k e]
  (let [file (aget (dg/event-target-files e) 0)]
    (swap! db/webentry-state assoc-in [:edit-values k] file)))

(defn end-web-form-settings-edit!
  []
  (swap! db/webentry-state dissoc :edit-values))

(defn save-image!
  [webentry]
  (let [webentry-id (:db/id webentry)
        entity-atom (r/cursor session/entities [webentry-id])
        {:keys [edit-values]} @db/webentry-state
        {:keys [webentry/logo webentry/background-image]} edit-values]
    (when-not (or (= :remove background-image)
                  (nil? background-image))
      (swap! entity-atom assoc :webentry/background-image "/img/spinner-icon.svg")
      (-> (conn/add-logo! {:file background-image :filename (.-name background-image)}
                          (fn [resp]
                            (let [status (:status resp)
                                  public-url (:body resp)]
                              (if (= status 200)
                                (entity-actions/*->field-update!
                                 webentry-id
                                 :webentry/background-image
                                 public-url
                                 #(logging/log "Successfully updated webentry background!")
                                 #(logging/error "Failed to update webentry background!" %))
                                (do
                                  (swap! entity-atom dissoc :webentry/background-image)
                                  (logging/error "Failed to upload background image " resp))))))
          (p/then (fn [_]
                    (end-web-form-settings-edit!)))))
    (when-not (or (= :remove logo)
                  (nil? logo))
      (swap! entity-atom assoc :webentry/logo "/img/spinner-icon.gif")
      (-> (conn/add-logo! {:file logo :filename (.-name logo)}
                          (fn [resp]
                            (let [status (:status resp)
                                  public-url (:body resp)]
                              (if (= status 200)
                                (entity-actions/*->field-update!
                                 webentry-id
                                 :webentry/logo
                                 public-url
                                 #(logging/log "Successfully updated webentry background!")
                                 #(logging/error "Failed to update webentry background!" %))
                                (do
                                  (swap! entity-atom dissoc :webentry/logo)
                                  (logging/error "Failed to upload webentry logo"))))))
          (p/then (fn [_]
                    (end-web-form-settings-edit!)))))))

(defn delete-webform!
  [webentry]
  (let [webentry-id (:db/id webentry)]
    (entity-actions/*->disable! webentry-id
                                (fn [_]
                                  (rf/dispatch [::event/set-first-webentry #{webentry-id}]))
                                (fn [_]))))

(defn start-delete-webform!
  [webentry]
  (modals/open-modal!
   delete-confirmation-modal/modal-key
   {:body       (loc/tr :webentry-delete [(:webentry/display-name webentry)])
    :on-delete! (fn [_]
                  (delete-webform! webentry))}))

(defn new-separator-kw
  [sep ordering]
  (let [separator-nums (->> ordering
                            (filter cu/separator-kw?)
                            (filter (fn [kw]
                                      (string/starts-with? (name kw) sep)))
                            (map (fn-> name (subs (count sep)) js/parseInt)))
        next-num (inc (apply max 0 separator-nums))]
    (keyword "separator" (str sep next-num))))

(defn select-fields
  [available-fields selected-fields save!]
  (let [tenant-schema @session/tenant-schema
        selected? (set selected-fields)
        field-settings (->> available-fields
                            (map (fn [f]
                                   [f
                                    (if (selected? f)
                                      :in-use
                                      :not-used)]))
                            (into {}))]
    (reset! db/modal-field-settings field-settings)
    (modals/open-modal!
     settings-curtain/modal-key
     {:header-text      (loc/tr :configure-webform-fields)
      :options          {:in-use   [:span.label-sm.no-wrap (loc/tr :in-use)]
                         :not-used [:span.label-sm.no-wrap (loc/tr :not-used)]}
      :values-row-width 2
      :label-row-width  10
      :state            db/modal-field-settings
      :fields-getter    (fn [dereffed-state]
                          (->>
                           dereffed-state
                           (sort-by (fn [[fld-attr _setting]]
                                      (->> (registry/get-field-schema tenant-schema fld-attr)
                                           :field/default-ord)))
                           (map
                            (fn [[k v]]
                              {:field/name      (loc/field-name k
                                                                (registry/get-field-schema
                                                                 tenant-schema
                                                                 k))
                               :field/value     v                                                   ;;(field/plain-setting v)
                               :field/disabled? (some #{v}
                                                      [:disabled-not-used :disabled-in-use
                                                       :disabled-mandatory])
                               :field/key       k})
                            )))
      :on-change!       (fn [k v]
                          (swap! db/modal-field-settings assoc k v))
      :on-save!         (fn []
                          (let [new-fields @db/modal-field-settings
                                to-add (->> new-fields
                                            (sort-by
                                             (fn [[fld-attr _setting]]
                                               (->> (registry/get-field-schema tenant-schema
                                                                               fld-attr)
                                                    :field/default-ord)))
                                            (filter (fn [[_k v]]
                                                      (= v :in-use)))
                                            (map first)
                                            (remove selected?))
                                not-used (->> new-fields
                                              (filter (fn [[_k v]]
                                                        (= v :not-used)))
                                              (map first)
                                              set)
                                new-fields (concat (->> selected-fields
                                                        (remove not-used))
                                                   to-add)]
                            (save! (vec new-fields))))
      :unsaved-changes? (fn []
                          (let [new-fields @db/modal-field-settings
                                to-add (->> new-fields
                                            (sort-by
                                             (fn [[fld-attr _setting]]
                                               (->> (registry/get-field-schema tenant-schema
                                                                               fld-attr)
                                                    :field/default-ord)))
                                            (filter (fn [[_k v]]
                                                      (= v :in-use)))
                                            (map first)
                                            (remove selected?))
                                not-used (->> new-fields
                                              (filter (fn [[_k v]]
                                                        (= v :not-used)))
                                              (map first)
                                              set)
                                new-fields (concat (->> selected-fields
                                                        (remove not-used))
                                                   to-add)]
                            (not= (sort new-fields)
                                  (sort selected-fields))))})))

(defn save-selected-fields!
  [entity-atom entity-type old-fields new-fields removed-field]
  (let [msg (merge
             {:db/id       (:db/id @entity-atom)
              :entity-type entity-type
              :field       :selected-fields
              :value       new-fields}
             (when removed-field
               {:removed-field removed-field}))
        local-path [:webentry/field-config entity-type :selected-fields]]
    (when (not= new-fields old-fields)
      (swap! entity-atom assoc-in local-path new-fields)
      (-> (conn/sendp! :webentry/update-entity-field msg)
          (p/then (fn []
                    ))
          (p/catch (fn [e]
                     (when (= new-fields (get-in @entity-atom local-path))
                       (swap! entity-atom assoc-in local-path old-fields))
                     (logging/error "error saving fields" e)))))))

(defn archive-webform!
  [entity-atom webform]
  (let [archived? (not (:common/archived? @entity-atom))]
    (swap! entity-atom assoc :common/archived? archived?)
    (-> (conn/sendp! :entity/update-attribute
                     {:db/id     (:db/id webform)
                      :attribute :common/archived?
                      :value     (true? archived?)})
        (p/then (fn []
                  ))
        (p/catch (fn [e]
                   (when (= archived? (get @entity-atom :common/archived?))
                     (swap! entity-atom assoc :common/archived? (not archived?)))
                   (logging/error "error saving fields" e))))))
